import { observer } from "mobx-react-lite";
import { DeleteTemplateModalStore } from "@/components/modal/delete-template/delete-template-modal-store";
import { UNTITLED_TEMPLATE_TITLE } from "@/domains/untitled/untitled";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { MDSModalDialog, MDSDialogSlotName } from "@/mds/components/overlays/dialog";

export interface DeleteTemplateModalProps {
  store: DeleteTemplateModalStore;
}

export const DeleteTemplateModal = observer<DeleteTemplateModalProps>(({ store }) => {
  return (
    <MDSModalDialog isOpen={store.isOpen} isDismissable handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Permanently delete “{store.template?.title || UNTITLED_TEMPLATE_TITLE}”?
      </MDSText>
      <div slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          Make sure you want to permanently delete this template.{" "}
          <MDSText as="span" variant={MDSTextVariant.ParagraphS} weight={MDSTextWeight.SemiBold}>
            You cannot undo this action.
          </MDSText>
        </MDSText>
      </div>
      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
        <MDSButton
          variant={MDSButtonVariant.DangerFilled}
          onClick={async () => {
            await store.handleSubmit();
            store.close();
          }}
        >
          Delete template
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
